<template>
	<div>
		<div class="banner">
			<el-carousel height="574px">
				<el-carousel-item v-for="item in 4" :key="item">
					<img src="../../../assets/images/home1.png" alt="">
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="mall_classify">
			<div class="title">Categories</div>
			<div class="list">
				<div class="item"  v-for="(item,index) in classify" :key="index" @click="toClassify(index)">{{item.name}}</div>
			</div>
		</div>
		<div class="recommend">
			<div class="title">Popular Products</div>
			<div class="list">
				<div class="item" v-for="(item,index) in productList" :key="index" @click="toDetail(item.id)">
					<div class="picture">
						<img :src="imgBaseUrl+item.image" alt="">
					</div>
					<div class="name line_two">{{item.name}}</div>
					<div class="price">£{{item.goods_price}}</div>
				</div>
			</div>
		</div>
		<div class="add_btn" v-if="page<total" @click="getMore">More products</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				classify:[],
				classifyActive:0,
				productList:[],
				page:1,
				total:0
			}
		},
		created(){
			this.getClassify();
		},
		methods:{
			getClassify(){
				this.$api.post('goods/getCategory',{},res=>{
					if(res.code == 1){
						this.classify = res.data;
						this.getList();
					}
				})
			},
			getMore(){
				if(this.page < this.total){
					this.page++;
					this.getList()
				}else{
					this.$message('暂无更多数据')
				}
			},
			getList(){
				var params = {
					is_hot:1,
					page:this.page
				}
				this.$api.post('goods/getGoodsList',params,res=>{
					if(res.code == 1){
						if(this.page == 1){
							this.productList = res.data.data
						}else{
							this.productList = this.productList.concat(res.data.data)
						}
						this.total = res.data.last_page;
					}
				})
			},
			// 查看分类
			toClassify(index){
				this.$router.push({ path: '/home/mall/classfiy', query: {index: index}})
			},
			toDetail(id){
				this.$router.push({path:'/home/mall/detail',query:{id:id}})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.banner{
		width: 100%;
		height: 574px;
		
		img{
			width: 100%;
			height: 100%;
		}
		::v-deep .el-carousel__indicators--horizontal{
			display: block;
			
		}
		::v-deep .el-carousel__indicator--horizontal button{
			display: block;
			width: 8px;
			height: 8px;
			background: #FFFFFF;
			opacity: 0.3;
			border-radius: 50%;
			padding: 0 ;
			margin-right: 30px;
		}
		::v-deep .el-carousel__indicator--horizontal.is-active button{
			opacity: 1;
		}	
	}
	.mall_classify{
		width: 100%;
		background: #5C707A;
		margin-top: 32px;
		padding-top: 30px;
		padding-bottom: 3px;
		.title{
			text-align: center;
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #F7F2EB;
			margin-bottom: 40px;
		}
		.list{
			display: flex;
			flex-wrap: wrap;
			width: 1200px;
			margin: 0 auto;
			.item{
				width: calc(100% / 6);
				height: 34px;
				line-height: 34px;
				text-align: center;
				border-left: 1px solid #F7F2EB;
				margin-bottom: 40px;
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				cursor: pointer;
				&:nth-child(6n+0){
					border-right: 1px solid #F7F2EB;
				}
				&:last-child{
					border-right: 1px solid #F7F2EB;
				}
			}
		}
	}
	.recommend{
		width: 100%;
		padding-top: 28px;
		.title{
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			text-align: center;
			margin-bottom: 50px;
		}
		.list{
			width: 1200px;
			margin: 0 auto;
			display: flex;
			flex-wrap: wrap;
			
			.item{
				width: 220px;
				height: 300px;
				background: #F7F2EB;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 10px;
				padding: 10px;
				margin-right: 25px;
				margin-bottom: 20px;
				cursor: pointer;
				&:nth-child(5n+0){
					margin-right: 0;
				}
				
				.picture{
					width: 100%;
					height: 180px;
					overflow: hidden;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.name{
					margin-top: 10px;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #5C707A;
					line-height: 24px;
				}
				.price{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #BF5F49;
					line-height: 30px;
				}
			}
		}
	}
	.add_btn{
		width: 182px;
		height: 58px;
		background: #5C707A;
		border-radius: 29px;
		margin: 86px auto 0;
		line-height: 58px;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #F7F2EB;
		margin-bottom: 400px;
		cursor: pointer;
	}
</style>